export const AttributesIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.586 2.88446C12.211 2.50936 11.7024 2.29858 11.172 2.29846H4C3.46957 2.29846 2.96086 2.50918 2.58579 2.88425C2.21071 3.25932 2 3.76803 2 4.29846V11.4705C2.00011 12.0009 2.2109 12.5095 2.586 12.8845L11.29 21.5885C11.7445 22.0401 12.3592 22.2936 13 22.2936C13.6408 22.2936 14.2555 22.0401 14.71 21.5885L21.29 15.0085C21.7416 14.5539 21.9951 13.9392 21.9951 13.2985C21.9951 12.6577 21.7416 12.043 21.29 11.5885L12.586 2.88446Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 8.29846C7.77614 8.29846 8 8.0746 8 7.79846C8 7.52232 7.77614 7.29846 7.5 7.29846C7.22386 7.29846 7 7.52232 7 7.79846C7 8.0746 7.22386 8.29846 7.5 8.29846Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
